import React, { useState, useCallback, useRef } from 'react';

import { SEND_AUDITION_FORM } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';

import styles from './css/AuditionForm.module.css';


const DEFAULT_FORM_DATA = {
  name: '',
  email: '',
  location: '',
  socialMediaLinks: '',
  reason: '',
};

function AmateurAuditionsForm(props) {
  const { handleAuditionFormToggle } = props;
  const [formData, setFormData] = useState(DEFAULT_FORM_DATA);
  const [message, setMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const ref = useRef(null);
  const scrollIntoStatusMessageView = () => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleInput = useCallback((e) => {
    const { value } = e.target;
    const field = e.target.id;
    setFormData({
      ...formData,
      [field]: value,
    });
  }, [formData]);

  const submitForm = useCallback((e) => {
    e.preventDefault();
    callApi(SEND_AUDITION_FORM, 'post', {}, formData, {}, false, false, false).
      then((res) => {
        if (res.status === 204) {
          setShowMessage(true);
          setMessage('Thank You for your submission, our producer will contact you shortly.');
          setSubmitted(true);
          setFormData(DEFAULT_FORM_DATA);
        }
      }).
      catch(() => {
        setShowMessage(true);
        scrollIntoStatusMessageView();
        setMessage('Name & E-mail are mandatory fields.');
      });
  }, [formData]);

  return (
    <div className={styles.amateurAuditionForm}>
      <button className={styles.close} onClick={handleAuditionFormToggle}>X</button>
      {!submitted &&
        <>
          <h1 className={styles.auditionFormHeader}>
            AUDITION FOR
          </h1>
          <h1 className={styles.auditionFormHeader}>
            NAKED NEWS ANCHOR
          </h1>
          <h6 className={styles.smallDisclaimer}>* MUST BE 18 YEARS OR OLDER</h6>
          <form action="" className={styles.auditionFormGrid}>
            <div className={styles.amateurAuditionFormInputs}>
              <label className={styles.label} htmlFor="name">NAME:</label>
              <input
                className={styles.input}
                id="name"
                placeholder={'Your Name'}
                required="required"
                type="text"
                value={formData.name}
                onChange={handleInput}
              />
            </div>
            <div className={styles.amateurAuditionFormInputs}>
              <label className={styles.label} htmlFor="email">CONTACT:</label>
              <input
                className={styles.input}
                id="email"
                placeholder={'Your email or phone number'}
                required="required"
                type="text"
                value={formData.email}
                onChange={handleInput}
              />
            </div>
            <div className={styles.amateurAuditionFormTextBoxContainer}>
              <label className={styles.label} htmlFor="email">SOCIAL MEDIA:</label>
              <textarea
                className={styles.socialMediaTextBox}
                cols={40}
                id="socialMediaLinks"
                maxLength={512}
                placeholder="Link any relevant accounts such as Instagram, Twitter, TikTok, personal website, etc."
                rows={5}
                value={formData.socialMediaLinks}
                onChange={handleInput}
              />
            </div>
            <div className={styles.amateurAuditionFormTextBoxContainer}>
              <label className={styles.label} htmlFor="email">YOUR STORY:</label>
              <textarea
                className={styles.textBox}
                cols={40}
                id="reason"
                maxLength={2048}
                placeholder="Tell us about yourself and why you want to be a Naked News Anchor"
                rows={5}
                value={formData.reason}
                onChange={handleInput}
              />
            </div>
            <button className={styles.auditionFormSubmit} onClick={submitForm}>
              Send
            </button>
          </form>
        </>}
      {showMessage && <h4 ref={ref} className={styles.auditionFormInfo}>{message}</h4>}
    </div>
  );

}

export default AmateurAuditionsForm;
